/**
 * The letters an avatar shows for a name: the first letter of the first and
 * last word, uppercased; one letter for a single word. An email is read by
 * its local part, split on the dots, underscores and hyphens people put
 * between their names. Words that do not start with a letter are skipped; a
 * name with no such word gives nothing, and the avatar falls back to the
 * person glyph.
 */
export const initialsOf = (name: string): string => {
  const source = name.includes('@') ? (name.split('@')[0] ?? '') : name;
  const words = source
    .trim()
    .split(/[\s._-]+/u)
    .filter((word) => /^\p{L}/u.test(word));
  if (words.length === 0) return '';
  const letter = (word: string | undefined) => [...(word ?? '')][0] ?? '';
  const last = words.length > 1 ? words[words.length - 1] : undefined;
  return `${letter(words[0])}${letter(last)}`.toUpperCase();
};
